<div class="mat-body text-center">
    <button type="button" class="btn-close mat-elevation-z0" mat-icon-button (click)="onClose()">
        <mat-icon>close</mat-icon>
    </button>

    <h2 class="mat-headline text-left">
        {{ 'dialog.confirm-transfer.info'|translate }}
    </h2>

    <ng-container>
        <div class="row">
            <div class="col-1 text-left"><img src="assets/images/signature.svg"/> </div>
            <div class="col-11 text-left" *ngIf="data.single">
                <span  class="mb-3 text-left" [innerHTML]="'dialog.confirm-signature.a-signer'|translate "></span>
                <span>{{data.phone}}</span>
                <span [innerHTML]="'dialog.confirm-signature.a-signer2'|translate "></span><br><br><br>
            </div>
            <div class="col-11 text-left" *ngIf="!data.single">
                <span  class="mb-3 text-left" [innerHTML]="'dialog.confirm-signature.multiple-signatories'|translate "></span>
                <span>{{data.phone}}</span>
                <span [innerHTML]="'dialog.confirm-signature.multiple-signatories2'|translate "></span><br><br><br>
            </div>
            </div>
    </ng-container>

    <button type="button" class="mat-elevation-z0" mat-raised-button color="blue" [mat-dialog-close]="true">
        <span>{{ 'general.accept'|translate }}</span>
    </button>
</div>
